import React from 'react';
import { ReorderRule } from '../types/reorderRule';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { instanceToPlain } from 'class-transformer';

export interface ReorderRuleContextProps {
  reorderRules: Map<string, ReorderRule>;
  setReorderRules: (reorderRules: Map<string, ReorderRule>) => void;
  groupedReorderRules: Map<string, ReorderRule[]>;
  reorderRulesLoading: boolean;
}

const defaultContext: ReorderRuleContextProps = {
  reorderRules: new Map(),
  setReorderRules: () => {},
  reorderRulesLoading: false,
  groupedReorderRules: new Map(),
};

export const ReorderRuleContext = React.createContext<ReorderRuleContextProps>(defaultContext);

interface ReorderRuleState {
  items: Record<string, any>[];
  loading: boolean;
}

export const reorderRuleSlice = createSlice({
  name: 'reorderRule',
  initialState: { items: [], loading: true } as ReorderRuleState,
  reducers: {
    reset: state => {
      state.items = [];
      state.loading = true;
    },
    setAll: (state, action: PayloadAction<ReorderRule[]>) => {
      state.items = action.payload.map(p => instanceToPlain(p));
    },
    addAll: (state, action: PayloadAction<ReorderRule[]>) => {
      const map = new Map([...state.items, ...action.payload.map(p => instanceToPlain(p))].map(pmd => [pmd.id, pmd]));
      state.items = [...map.values()];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});
